import { datadogRum } from "@datadog/browser-rum";

import config from "config/index";

export const initDatadog = () => {
  if (!window.origin.match("localhost")) {
    window.console.log(
      "Loading Datadog for environment: " + config.ENVIRONMENT
    );

    datadogRum.init({
      applicationId: "112734ae-c921-4341-a6b9-584bb5390798",
      clientToken: "pub2f9827adc6163e9f09aa7dc75736bca8",
      site: "us3.datadoghq.com",
      service: "portal-ui",
      env: config.ENVIRONMENT.toLowerCase(),
      sessionSampleRate: 100,
      trackUserInteractions: true,
      defaultPrivacyLevel: config.DATADOG_PRIVACY_LEVEL,
      trackSessionAcrossSubdomains: true,
      trackLongTasks: true,
      useSecureSessionCookie: true,
      allowedTracingUrls: [
        { match: "https://*.codat.io", propagatorTypes: ["tracecontext"] },
        {
          match: "https://*.codatprivate.io",
          propagatorTypes: ["tracecontext"],
        },
      ],
    });
  }
};
